import { createResourceStore } from './createResourceStore';

const useToolPromptsStore = createResourceStore({
  endpoint: '/admin/tool-prompts',
  collectionKey: 'toolPrompts',
  itemKey: 'toolPrompt',
  methods: {
    fetch: 'fetchAllToolPrompts',
    create: 'createToolPrompt',
    update: 'updateToolPrompt',
    delete: 'deleteToolPrompt',
  },
});

export default useToolPromptsStore;
